import { SearchResultData, SearchResultDataValue, SearchResultType } from "@kaltura/mediaspace-shared-types";

export type TypedSearchResultDataValue = SearchResultDataValue & {
    type: SearchResultType;
    items?: Omit<TypedSearchResultDataValue, "type">[];
};

export const prepareItems = (srd: SearchResultData[]) => {
    // add type to each inner-item
    const itemsWithType: TypedSearchResultDataValue[] = [];
    for (let i = 0; i < srd.length; i++) {
        for (let j = 0; j < srd[i].value.length; j++) {
            // remove highlight tags from result text
            const text = srd[i].value[j].text.replace("<em>", "").replace("</em>", "");
            itemsWithType.push({ ...srd[i].value[j], text: text, type: srd[i].key });
        }
    }

    // separate timed/non-timed/tags items
    let timed: TypedSearchResultDataValue[] = [];
    const tags: TypedSearchResultDataValue[] = [];
    const others: TypedSearchResultDataValue[] = [];
    for (const item of itemsWithType) {
        if (item.startTime) {
            // filter out comments where startTime = 0, either as string or int
            if ((item.type !== "quiz" && item.type !== "polls") || item.startTime.toString() !== "0") {
                timed.push(item);
                continue;
            }
        }
        if (item.type === "tags") {
            tags.push(item);
            continue;
        }
        others.push(item);
    }

    // sort timed items
    timed = timed.sort((a, b) => {
        if (a.startTime && b.startTime) {
            return a.startTime - b.startTime;
        }
        // this can't happen, we filtered out only items with startTime - but typescript.
        return 0;
    });

    // return all, sorted
    return timed.concat(others, { type: "tags", items: tags, text: "whatever" });
};
